<template>
    <div id="app">
        <router-view class="app-view"></router-view>
        <Alert/>
        <Loading/>
        <Confirm/>
        <Toast/>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import Alert from '@/ui/alert/index.vue';
import Loading from '@/ui/loading/index.vue';
import Confirm from '@/ui/confirm/index.vue';
import Toast from '@/ui/toast/index.vue';
import Native from '@/common/js/utils/native/index';
(function() {
    // 针对Android设备，控制页面不受微信系统字体大小影响
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize();
    } else {
        if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
        } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", handleFontSize);
            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
    }
    function handleFontSize() {
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
        WeixinJSBridge.on('menu:setfont', function() {
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
        });
    }
})();

export default {
    name: 'app',
    data() {
        return {
            // transitionName: '',
            // 直接刷新页面进入, 以下路由需要依赖weixinjs和签名
            relyWechatResource: {
                "/pay": true,
                "/quotaQuery": true
            },
            num: 0,
            perData: {}
        }
    },
    created() {
        this.wxReady();
    },
    mounted() {
       this.init();
    },
    computed: {
        ...mapState({
            ENV: (state) => state.ENV
        })
    },
    methods: {
        // 补丁
        wxReady() {
            let {commit} = this.$store;
            let ready = () =>{
                const ua = navigator.userAgent.toLocaleLowerCase();
                if (ua.includes('micromessenger') && window.__wxjs_environment === 'miniprogram') {
                    commit('setValue', {
                        key: 'ENV',
                        value: 'miniprogram'
                    });
                }
            };
            if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
                document.addEventListener('WeixinJSBridgeReady', ready, false);
            } else {
                ready();
            }
        },

        // 微信环境初始化处理
        wechatHandle(type, msg, level, isTip) {
            let that = this;
            let {commit, state} = that.$store;
            // sdk script加载
            if (level === 1) {
                if (type === 'loading' && isTip) {
                    commit('Toast/show', {text: msg, timeOut: true}, {root: true});
                }
                if (type === 'error') {
                    state.third.wxjs = false;
                    commit('Toast/close', {}, {root: true});
                }
                if (type === 'success') {
                    state.third.wxjs = true;
                }
            }

            // 签名注册
            if (level === 2) {
                if (type === 'success') {
                    Native.getNetworkType((str) => {
                        state.third.networkType = str;
                        window.networkType = str;
                    });
                    state.third.wxSign = true;
                    commit('Toast/close', {}, {root: true});
                }
                if (type === 'error') {
                    state.third.wxSign = false;
                    commit('Toast/close', {}, {root: true});
                    // commit('Confirm/show', {
                    //     text: msg + ' 是否重试？',
                    //     confirmCallback: () => {
                    //         that.init();
                    //     }
                    // });
                }
            }
        },
        init() {
            let {commit, state} = this.$store;
            let that = this;
            if (that.ENV === 'pc') return;
            Native.init((type, msg, level) => {
                let isTip = state.currentRoutePath in that.relyWechatResource;
                let cb = that[that.ENV + 'Handle'];
                if (typeof cb !== 'function') return;
                cb(type, msg, level, isTip);
            });
        }
    },
    components: {
        Alert,
        Loading,
        Confirm,
        Toast
    }
}
</script>

<style lang="less">
  @import "common/less/config.less";
  @import "common/less/common.less";
  #app {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        -webkit-text-size-adjust: 100% ; // 针对ios设备，控制页面不受微信系统字体大小影响
        .app-view {
            transition: all .5s cubic-bezier(.55,0,.1,1);
        }
        .slide-left-enter, .slide-right-leave-active {
            opacity: 0;
            -webkit-transform: translate(30px, 0);
            transform: translate(30px, 0);
        }
        .slide-left-leave-active, .slide-right-enter {
            opacity: 0;
            -webkit-transform: translate(-30px, 0);
            transform: translate(-30px, 0);
        }
        .fade-enter-active, .fade-leave-active {
            transition: opacity .5s ease;
        }
        .fade-enter, .fade-leave-active {
            opacity: 0
        }
  }
    .jc{
        position: fixed;
        right: 0;
        bottom: 0;
        width: 40px;
        height: 40px;
        z-index: 99999;
        text-align: center;
        line-height: 40px;
        background: rgba(0, 0, 0, 0);
    }
</style>



// WEBPACK FOOTER //
// src/App.vue